import React,{useState, useEffect}  from 'react';

import Sides from '../Bars/Pythonsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";

function Pforloop(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
     <div>
<Sides/>

<Helmet>
 
  <title>Learn Free Python For Looping Beginners Tutorials CodeExampler</title>
<meta name="description" content="Python forloop tutorial for beginners.This python for loop is used to repeat a particular piece of code for a fixed no of times" />
<meta name="keywords" content="codeexampler,programming language,tutorial for begineers,For loop python,python for loop,python for loop range ,python for loop with index,python for loop break ,python for loop with list,python for loop example" />
<link rel="canonical" href="https://www.codeexampler.com/python-for-loop" />
</Helmet>

<div className='lg:pl-56'>


    <h1 className="m-4 mh1">Python for loop</h1>

    <div className="first">
        <a href="/python-while">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/python-break">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>


    <h2 className="mt-4 mh2">For loop Python With Break and Continue:
</h2>
<p className="mt-4 para">1, The body of the loop must be executed until the given condition is false<br/>
2, In Python for loop semicolon, must be used <br/>
3, This Python for loop is used to repeat a particular piece of code for a fixed no of times<br/>
</p>


<h2 className='headings'>Python for loop Syntax:</h2>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"500vh"}}>
          <code >
            {"\n"}
                <span className="qwerty-7">for</span>
                <span className="qwerty-4"> iterator_var</span>
                <span className="qwerty-5"> in</span>
                <span className="qwerty-2"> sequence</span>
                <span className="qwerty-1">:</span>
            {"\n"}
                <span className="qwerty-3">   statements</span>
            {"\n"}{"\n"}
                 </code>
        </pre>
        </div>     




<h2 className='headings'>Q-Write a program to print a number from 1 to 10 in Python for a loop range Example?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-7">for</span>
                 <span className="qwerty-4"> a</span>
                 <span className="qwerty-5"> in</span>
                 <span className="qwerty-6"> range</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-2">1</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-2">10</span>
                 <span className="qwerty-1">)</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
             <span className="qwerty-3">   print</span>
                <span className="qwerty-1">(</span>
                <span className="qwerty-4">a</span>
                <span className="qwerty-1">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>  
         <h5 className='headings'> Output : </h5>
          <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
             <pre style={{maxHeight:"100vh"}}>
                 <code >
                     {"\n"}
                         <span className="qwerty-3">1</span>
                         {"\n"} 
                         <span className="qwerty-3">2</span>
                         {"\n"} 
                         <span className="qwerty-3">3</span>
                         {"\n"} 
                         <span className="qwerty-3">4</span>
                         {"\n"} 
                         <span className="qwerty-3">5</span>
                         {"\n"} 
                         <span className="qwerty-3">6</span>
                         {"\n"} 
                         <span className="qwerty-3">7</span>
                         {"\n"} 
                         <span className="qwerty-3">8</span>
                         {"\n"} 
                         <span className="qwerty-3">9</span>
                         {"\n"} 
                              {"\n"}      
               </code>
                 </pre>
                 </div>





<h2 className='headings'>Q-Write a program to print  name when the program is complete Python for a loop range Example?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-7">for</span>
                 <span className="qwerty-4"> a</span>
                 <span className="qwerty-5"> in</span>
                 <span className="qwerty-6"> range</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-2">1</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-2">10</span>
                 <span className="qwerty-1">)</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
             <span className="qwerty-3">   print</span>
                <span className="qwerty-1">(</span>
                <span className="qwerty-4">a</span>
                <span className="qwerty-1">)</span>
             {"\n"}
             <span className="qwerty-3">print</span>
                <span className="qwerty-1">("</span>
                <span className="qwerty-10">Code Exampler</span>
                <span className="qwerty-1">")</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>  
         <h5 className='headings'> Output : </h5>
          <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
             <pre style={{maxHeight:"100vh"}}>
                 <code >
                     {"\n"}
                         <span className="qwerty-3">1</span>
                         {"\n"} 
                         <span className="qwerty-3">2</span>
                         {"\n"} 
                         <span className="qwerty-3">3</span>
                         {"\n"} 
                         <span className="qwerty-3">4</span>
                         {"\n"} 
                         <span className="qwerty-3">5</span>
                         {"\n"} 
                         <span className="qwerty-3">6</span>
                         {"\n"} 
                         <span className="qwerty-3">7</span>
                         {"\n"} 
                         <span className="qwerty-3">8</span>
                         {"\n"} 
                         <span className="qwerty-3">9</span>
                         {"\n"} 
                         <span className="qwerty-8">Code Exampler</span>
                         {"\n"} 
                              {"\n"}      
               </code>
                 </pre>
                 </div>
              





<h2 className='headings'>Q-Write a program to print a name again with for Loop in Python?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-7">for</span>
                 <span className="qwerty-4"> a</span>
                 <span className="qwerty-5"> in</span>
                 <span className="qwerty-6"> range</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-2">1</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-2">10</span>
                 <span className="qwerty-1">)</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
             <span className="qwerty-3">   print</span>
                <span className="qwerty-1">(</span>
                <span className="qwerty-4">a</span>
                <span className="qwerty-1">)</span>
             {"\n"}
             <span className="qwerty-3">   print</span>
                <span className="qwerty-1">("</span>
                <span className="qwerty-10">Ram Ram</span>
                <span className="qwerty-1">")</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>  
         <h5 className='headings'> Output : </h5>
          <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
             <pre style={{maxHeight:"100vh"}}>
                 <code >
                     {"\n"}
                         <span className="qwerty-8">1</span>
                         {"\n"} 
                         <span className="qwerty-3">Ram Ram</span>
                         {"\n"} 
                         <span className="qwerty-8">2</span>
                         {"\n"} 
                         <span className="qwerty-3">Ram Ram</span>
                         {"\n"} 
                         <span className="qwerty-8">3</span>
                         {"\n"} 
                         <span className="qwerty-3">Ram Ram</span>
                         {"\n"} 
                         <span className="qwerty-8">4</span>
                         {"\n"} 
                         <span className="qwerty-3">Ram Ram</span>                        
                         {"\n"} 
                         <span className="qwerty-8">5</span>
                         {"\n"} 
                         <span className="qwerty-3">Ram Ram</span>
                         {"\n"} 
                         <span className="qwerty-8">6</span>
                         {"\n"} 
                         <span className="qwerty-3">Ram Ram</span>
                           {"\n"} 
                         <span className="qwerty-8">7</span>
                         {"\n"} 
                         <span className="qwerty-3">Ram Ram</span>
                         {"\n"} 
                         <span className="qwerty-8">8</span>
                         {"\n"} 
                         <span className="qwerty-3">Ram Ram</span>
                         {"\n"} 
                         <span className="qwerty-8">9</span>
                         {"\n"} 
                         <span className="qwerty-3">Ram Ram</span>
                         {"\n"} 
                              {"\n"}      
               </code>
                 </pre>
                 </div>




<h2 className='headings'>Q-Write a program to combine a no and name in python for a loop?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-7">for</span>
                 <span className="qwerty-4"> a</span>
                 <span className="qwerty-5"> in</span>
                 <span className="qwerty-6"> range</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-2">1</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-2">10</span>
                 <span className="qwerty-1">)</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
             <span className="qwerty-3">   print</span>
                <span className="qwerty-1">("</span>
                <span className="qwerty-10">Ram Ram </span>
                <span className="qwerty-1">",</span>
                <span className="qwerty-4">a</span>
                <span className="qwerty-1">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>  
         <h5 className='headings'> Output : </h5>
          <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
             <pre style={{maxHeight:"100vh"}}>
                 <code >
                     {"\n"}
                         <span className="qwerty-3">Ram Ram</span>
                         <span className="qwerty-2"> 1</span>
                         {"\n"} 
                         <span className="qwerty-3">Ram Ram</span>
                         <span className="qwerty-2"> 2</span>
                         {"\n"} 
                         <span className="qwerty-3">Ram Ram</span>
                         <span className="qwerty-2"> 3</span>
                         {"\n"} 
                         <span className="qwerty-3">Ram Ram</span>
                         <span className="qwerty-2"> 4</span>
                         {"\n"} 
                         <span className="qwerty-3">Ram Ram</span>
                         <span className="qwerty-2"> 5</span>
                         {"\n"} 
                         <span className="qwerty-3">Ram Ram</span>
                         <span className="qwerty-2"> 6</span>
                           {"\n"} 
                         <span className="qwerty-3">Ram Ram</span>
                         <span className="qwerty-2"> 7</span>
                         {"\n"} 
                         <span className="qwerty-3">Ram Ram</span>
                         <span className="qwerty-2"> 8</span>
                         {"\n"}  
                         <span className="qwerty-3">Ram Ram</span>
                         <span className="qwerty-2"> 9</span>
                         {"\n"} 
                              {"\n"}      
               </code>
                 </pre>
                 </div>


<h2 className="mt-4 mh2">Python Fibonacci Series or code :</h2>



<h2 className='headings'>Q-Write a program to Fibonacci series or python Fibonacci code in Python for loop?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
             <span className="qwerty-4">a</span>
                  <span className="qwerty-9"> = </span>
                  <span className="qwerty-8">0</span>
                  <span className="qwerty-1">;</span>
              <span className="qwerty-4"> b</span>
                  <span className="qwerty-9"> = </span>
                  <span className="qwerty-8">1</span>
                  <span className="qwerty-1">;</span>
              <span className="qwerty-4"> c</span>
                  <span className="qwerty-9"> = </span>
                  <span className="qwerty-8">0</span>
                  <span className="qwerty-1">;</span>
             {"\n"}
             <span className="qwerty-3">print</span>
                <span className="qwerty-1">(</span>
                <span className="qwerty-4">a</span>
                <span className="qwerty-1">," ",</span>
                <span className="qwerty-4">b</span>
                <span className="qwerty-1">)</span>
              {"\n"}
                 <span className="qwerty-7">for</span>
                 <span className="qwerty-4"> i</span>
                 <span className="qwerty-5"> in</span>
                 <span className="qwerty-6"> range</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-2">1</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-2">10</span>
                 <span className="qwerty-1">)</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
             <span className="qwerty-4">    c</span>
                  <span className="qwerty-9"> = </span>
                  <span className="qwerty-4">a</span>
                  <span className="qwerty">+</span>
                  <span className="qwerty-4">b</span>
             {"\n"}
             <span className="qwerty-3">    print</span>
                <span className="qwerty-1">(</span>
                <span className="qwerty-4">c</span>
                <span className="qwerty-1">)</span>
             {"\n"}
             <span className="qwerty-4">    a</span>
                  <span className="qwerty-9"> = </span>
                  <span className="qwerty-4">b</span>
             {"\n"}
             <span className="qwerty-4">    b</span>
                  <span className="qwerty-9"> = </span>
                  <span className="qwerty-4">c</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>  
         <h5 className='headings'> Output : </h5>
          <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
             <pre style={{maxHeight:"100vh"}}>
                 <code >
                     {"\n"}
                         <span className="qwerty-3">0</span>
                         {"\n"} 
                         <span className="qwerty-3">1</span>
                         {"\n"} 
                         <span className="qwerty-3">1</span>
                         {"\n"} 
                         <span className="qwerty-3">2</span>
                         {"\n"} 
                         <span className="qwerty-3">3</span>
                         {"\n"} 
                         <span className="qwerty-3">5</span>
                         {"\n"} 
                         <span className="qwerty-3">8</span>
                         {"\n"} 
                         <span className="qwerty-3">13</span>
                         {"\n"} 
                         <span className="qwerty-3">21</span>
                         {"\n"} 
                         <span className="qwerty-3">34</span>
                         {"\n"} 
                         <span className="qwerty-3">55</span>
                         {"\n"} 
                              {"\n"}      
               </code>
                 </pre>
                 </div>


<h2 className='headings'>Q-Write a program to input an integer number and print its sum by using for loop in Python?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-4">sum</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-2">0</span>
             {"\n"}
             <span className="qwerty-7">for</span>
                 <span className="qwerty-4"> i</span>
                 <span className="qwerty-5"> in</span>
                 <span className="qwerty-6"> range</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-2">1</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-2">5</span>
                 <span className="qwerty-1">)</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
             
             <span className="qwerty-4">    n</span>
                  <span className="qwerty-9"> = </span>
                  <span className="qwerty-2">int</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-8">input</span>
                  <span className="qwerty-6">(</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-10">Enter </span>
                  <span className="qwerty-5">%d</span>
                  <span className="qwerty-10"> no </span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-4">%i</span>
                  <span className="qwerty-6">)</span>
                  <span className="qwerty-1">)</span>
              {"\n"}
                 <span className="qwerty-8">    sum</span>
                 <span className="qwerty-1">=</span>
                 <span className="qwerty-4">sum</span>
                 <span className="qwerty">+</span>
                 <span className="qwerty-2">n</span>
             {"\n"}
                 <span className="qwerty-3">print</span>
                 <span className="qwerty-1">("</span>
                 <span className="qwerty-10">Sum=</span>
                 <span className="qwerty-5">%d</span>
                 <span className="qwerty-1">"</span>
                 <span className="qwerty-8">%sum</span>
                 <span className="qwerty-1">)</span>
             {"\n"}
             {"\n"}
                  </code>
         </pre>
         </div>          
         <h5 className='headings'> Output : </h5>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
              <pre style={{maxHeight:"100vh"}}>
                  <code >
                  {"\n"}
                          <span className="qwerty-8">Enter 1 no : </span>
                          <span className="qwerty-3">42</span>
                          {"\n"}    
                          <span className="qwerty-4">Sum = </span>
                          <span className="qwerty-2">42</span>
                          {"\n"}    
                          <span className="qwerty-8">Enter 2 no : </span>
                          <span className="qwerty-3">54</span>
                          {"\n"}    
                          <span className="qwerty-4">Sum = </span>
                          <span className="qwerty-2">96</span>
                          {"\n"}    
                          <span className="qwerty-8">Enter 3 no : </span>
                          <span className="qwerty-3">35</span>
                          {"\n"}    
                          <span className="qwerty-4">Sum = </span>
                          <span className="qwerty-2">131</span>
                          {"\n"}    
                          <span className="qwerty-8">Enter 4 no : </span>
                          <span className="qwerty-3">34</span>
                          {"\n"}    
                          <span className="qwerty-4">Sum = </span>
                          <span className="qwerty-2">157</span>
                          {"\n"}    
                          {"\n"}    
                </code>
                  </pre>
                  </div>  


<p className="mt-4 para">If you don't know about input in Python so check on <a href="https://www.codeexampler.com/python-input"> Python input tutorial</a>.</p>

<h2 className="mt-4 mh2">Break Python for loop:</h2>



<h2 className='headings'>Q-Write a program to input an integer number and print its sum by using for loop and break if n==0 in Python?</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty-4">sum</span>
                 <span className="qwerty-1"> = </span>
                 <span className="qwerty-2">0</span>
             {"\n"}
             <span className="qwerty-7">for</span>
                 <span className="qwerty-4"> i</span>
                 <span className="qwerty-5"> in</span>
                 <span className="qwerty-6"> range</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-2">1</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-2">11</span>
                 <span className="qwerty-1">)</span>
                 <span className="qwerty-1">:</span>
             {"\n"}
             
             <span className="qwerty-4">    n</span>
                  <span className="qwerty-9"> = </span>
                  <span className="qwerty-2">int</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-8">input</span>
                  <span className="qwerty-6">(</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-10">Enter a no </span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-6">)</span>
                  <span className="qwerty-1">)</span>
              {"\n"}
                  <span className="qwerty-6">    if</span>
                  <span className="qwerty-4"> n</span>
                  <span className="qwerty">==</span>
                  <span className="qwerty-2">0</span>
                  <span className="qwerty-1">:</span>
              {"\n"}
                  <span className="qwerty-7">        break</span>
              {"\n"}
                  <span className="qwerty-6">    else</span>
                  <span className="qwerty-1"> :</span>
              {"\n"}
                 <span className="qwerty-8">        sum</span>
                 <span className="qwerty-1">=</span>
                 <span className="qwerty-4">sum</span>
                 <span className="qwerty">+</span>
                 <span className="qwerty-2">n</span>
             {"\n"}
                 <span className="qwerty-3">        print</span>
                 <span className="qwerty-1">("</span>
                 <span className="qwerty-10">Sum=</span>
                 <span className="qwerty-5">%d</span>
                 <span className="qwerty-1">"</span>
                 <span className="qwerty-8">%sum</span>
                 <span className="qwerty-1">)</span>
             {"\n"}
             {"\n"}
                  </code>
         </pre>
         </div>          
         <h5 className='headings'> Output : </h5>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
              <pre style={{maxHeight:"100vh"}}>
                  <code >
                  {"\n"}
                          <span className="qwerty-8">Enter a no : </span>
                          <span className="qwerty-3">42</span>
                          {"\n"}    
                          <span className="qwerty-4">Sum = </span>
                          <span className="qwerty-2">42</span>
                          {"\n"}    
                          <span className="qwerty-8">Enter a no : </span>
                          <span className="qwerty-3">54</span>
                          {"\n"}    
                          <span className="qwerty-4">Sum = </span>
                          <span className="qwerty-2">96</span>
                          {"\n"}    
                          <span className="qwerty-8">Enter a no : </span>
                          <span className="qwerty-3">0</span>
                          {"\n"}    
                          {"\n"}    
                </code>
                  </pre>
                  </div>


<h2 className="mt-4 mh2">Counting table by using input:</h2>




<h2 className='headings'>Q-Write a program to input a no and create a table by using for loop in Python?</h2>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"500vh"}}>
          <code >
            {"\n"}
            <span className="qwerty-4">n</span>
                  <span className="qwerty-9"> = </span>
                  <span className="qwerty-2">int</span>
                  <span className="qwerty-1">(</span>
                  <span className="qwerty-8">input</span>
                  <span className="qwerty-6">(</span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-10">Enter a no </span>
                  <span className="qwerty-1">"</span>
                  <span className="qwerty-6">)</span>
                  <span className="qwerty-1">)</span>
              {"\n"}
             <span className="qwerty-7">for</span>
                 <span className="qwerty-4"> i</span>
                 <span className="qwerty-5"> in</span>
                 <span className="qwerty-6"> range</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-2">1</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-2">11</span>
                 <span className="qwerty-1">)</span>
                 <span className="qwerty-1">:</span>
              {"\n"}
              <span className="qwerty-10">    print</span>
                 <span className="qwerty-1">("</span>
                 <span className="qwerty-10">%d</span>
                 <span className="qwerty">*</span>
                 <span className="qwerty-10">%d</span>
                 <span className="qwerty-1">=</span>
                 <span className="qwerty-10">%d</span>
                 <span className="qwerty-1">"</span>
                 <span className="qwerty-8">%</span>
                 <span className="qwerty-6">(</span>
                 <span className="qwerty-8">n</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-8">i</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-8">n</span>
                 <span className="qwerty">*</span>
                 <span className="qwerty-8">i</span>
                 <span className="qwerty-6">)</span>
                 <span className="qwerty-1">)</span>
            {"\n"}{"\n"}
                 </code>
        </pre>
        </div>          
        <h5 className='headings'> Output : </h5>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
              <pre style={{maxHeight:"100vh"}}>
                  <code >
                  {"\n"}
                          <span className="qwerty-3">Enter a no : </span>
                          <span className="qwerty-5">4</span>
                          {"\n"}    
                          <span className="qwerty-4">4</span>
                          <span className="qwerty"> * </span>
                          <span className="qwerty-8">1</span>
                          <span className="qwerty-4"> = </span>
                          <span className="qwerty-2">4</span>
                          {"\n"}    
                          <span className="qwerty-4">4</span>
                          <span className="qwerty"> * </span>
                          <span className="qwerty-8">2</span>
                          <span className="qwerty-1"> = </span>
                          <span className="qwerty-2">8</span>
                          {"\n"}    
                          <span className="qwerty-4">4</span>
                          <span className="qwerty"> * </span>
                          <span className="qwerty-8">3</span>
                          <span className="qwerty-1"> = </span>
                          <span className="qwerty-2">12</span>
                          {"\n"}    
                          <span className="qwerty-4">4</span>
                          <span className="qwerty"> * </span>
                          <span className="qwerty-8">4</span>
                          <span className="qwerty-1"> = </span>
                          <span className="qwerty-2">16</span>
                          {"\n"}    
                          <span className="qwerty-4">4</span>
                          <span className="qwerty"> * </span>
                          <span className="qwerty-8">5</span>
                          <span className="qwerty-1"> = </span>
                          <span className="qwerty-2">20</span>
                          {"\n"}    
                          <span className="qwerty-4">4</span>
                          <span className="qwerty"> * </span>
                          <span className="qwerty-8">6</span>
                          <span className="qwerty-1"> = </span>
                          <span className="qwerty-2">24</span>
                          {"\n"}    
                          <span className="qwerty-4">4</span>
                          <span className="qwerty"> * </span>
                          <span className="qwerty-8">7</span>
                          <span className="qwerty-1"> = </span>
                          <span className="qwerty-2">28</span>
                          {"\n"}    
                          <span className="qwerty-4">4</span>
                          <span className="qwerty"> * </span>
                          <span className="qwerty-8">8</span>
                          <span className="qwerty-1"> = </span>
                          <span className="qwerty-2">32</span>
                          {"\n"}    
                          <span className="qwerty-4">4</span>
                          <span className="qwerty"> * </span>
                          <span className="qwerty-8">9</span>
                          <span className="qwerty-1"> = </span>
                          <span className="qwerty-2">36</span>
                          {"\n"}    
                          <span className="qwerty-4">4</span>
                          <span className="qwerty"> * </span>
                          <span className="qwerty-8">10</span>
                          <span className="qwerty-1"> = </span>
                          <span className="qwerty-2">40</span>
                          {"\n"}    
                                                 {"\n"}    
                          {"\n"}    
                </code>
                  </pre>
                  </div>


<h2 className="mt-4 mh2">Use (end=" ") in Python:</h2>


<h2 className='headings'>Q-Write a program to input a no ndcreate multiply by using (end=" ") inside for loop in Python?</h2>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"500vh"}}>
          <code >
            {"\n"}
            <span className="qwerty-7">for</span>
                 <span className="qwerty-4"> i</span>
                 <span className="qwerty-5"> in</span>
                 <span className="qwerty-6"> range</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-2">1</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-2">6</span>
                 <span className="qwerty-1">)</span>
                 <span className="qwerty-1">:</span>
              {"\n"}
              <span className="qwerty-3">   print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">i</span>
                 <span className="qwerty">*</span>
                 <span className="qwerty-4">i</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-8">end</span>
                 <span className="qwerty-1">=</span>
                 <span className="qwerty-10">" "</span>
                 <span className="qwerty-1">)</span>
            {"\n"}{"\n"}
                 </code>
        </pre>
        </div>          
        <h5 className='headings'> Output : </h5>
         <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
              <pre style={{maxHeight:"100vh"}}>
                  <code >
                  {"\n"}
                          <span className="qwerty-8">1  4   9   16  25 </span>
                          {"\n"}    
                          {"\n"}    
                </code>
                  </pre>
                  </div>

  <h1 className="mt-5">  </h1>
      
  <div className="back">
        <a href="/python-while">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/python-break">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div></div>
)

}
export default Pforloop;